import React from "react";
import './Input.scss';

type HexpertInputProps = {
  placeHolder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Input = ({ placeHolder, value, onChange }: HexpertInputProps) => {
  return (
    <input
      placeholder={placeHolder}
      onChange={(e) => onChange(e)}
      value={value}
      className={"c-hex-input"}
    />
  );
};
